export { default } from './BarresDiputats';
